/** Bundle Group Selection */
$('.bundle-group-wrapper .group-tabs .tab-item').on('click', function () {
  var $this = $(this),
    id = $this.attr('id');

  $('.bundle-group-wrapper .group-tabs .tab-item').removeClass('active');
  $('.bundle-main-content .tab-content').removeClass('active');
  $this.addClass('active');
  $('.bundle-main-content .tab-content[data-id="' + id + '"]').addClass('active');

  if ($(window).width() < 992) {
    //$('.bundle-main-content .tab-content-inner').slick('refresh');
  }
});

$('.bundle-item .bundle-options .variant-option').on('click', function () {
  var $this = $(this);

  $this.parent().find('.variant-option').removeClass('active');
  $this.addClass('active');

  if ($this.hasClass('size-variant')) {
    if ($this.parents('.bundle-info').find('.color-option').length > 0) {
      var size = $this.data('size');
      var variantImg = $this
        .parents('.bundle-info')
        .find('.color-for-size[data-size="' + size + '"] .active')
        .data('img');

      $this.parents('.bundle-info').find('.color-for-size').removeClass('active');
      $this
        .parents('.bundle-info')
        .find('.color-for-size[data-size="' + size + '"]')
        .addClass('active');
      $this.parents('.bundle-info').find('.bundle-image').attr('src', variantImg);
    } else {
      var variantImg = $this.data('img'),
        variantID = $this.data('variant-id');
      $this.parents('.bundle-info').find('.bundle-image').attr('src', variantImg);
      $this.parents('.bundle-info').find('input[name="default-variant"]').val(variantID);
    }

    // Stock state is determined by the active color swatch (data-out-stock on
    // color variants), not the size span. Checking size-level OOS here caused
    // false positives when Shopify's available flag reflects location-based
    // inventory restrictions that don't match admin totals.
    var activeColor = $this.parents('.bundle-info').find('.color-for-size.active .color-variant.active');
    if (activeColor.length > 0 && activeColor.data('out-stock') == true) {
      $this.parents('.bundle-item').find('.add-bundle').addClass('out-of-stock');
      $this.parents('.bundle-item').find('.add-bundle').text('Out of Stock');
    } else {
      $this.parents('.bundle-item').find('.add-bundle').removeClass('out-of-stock');
      $this.parents('.bundle-item').find('.add-bundle').text('+ Add to bundle');
    }
  }

  if ($this.hasClass('color-variant')) {
    var variantImg = $this.data('img');
    $this.parents('.bundle-info').find('.bundle-image').attr('src', variantImg);
  }
});

var blockTtemsWrap = $('.bundle-bottom-wrap .bundle-block-items'),
  minBlocks = blockTtemsWrap.data('min-blocks'),
  maxBlocks = blockTtemsWrap.data('max-blocks');

// Function to manage bundle spots automatically
function manageBundleSpots() {
  var blockItems = $('.bundle-bottom-wrap .bundle-block-items .block-item');
  var filledSpots = $('.bundle-block-items .added-item').length;
  var totalSpots = blockItems.length;

  // Always maintain minimum 3 spots
  if (totalSpots < 3) {
    for (var i = totalSpots; i < 3; i++) {
      blockTtemsWrap.append('<div class="block-item"><span class="placeholder">ONO</span></div>');
    }
  }

  // Add one extra spot when 3+ items are filled
  if (filledSpots >= 3 && totalSpots <= filledSpots) {
    blockTtemsWrap.append('<div class="block-item"><span class="placeholder">ONO</span></div>');
  }

  // Remove extra spots when there are 4+ spots and user removes items
  if (totalSpots > 3 && filledSpots < totalSpots - 1) {
    $('.bundle-block-items .block-item').not('.added-item').last().remove();
  }

  // Update left bundle count
  var newLeftCount = $('.bundle-block-items .block-item').not('.added-item').length;
  $('input[name="left-bundle-count"]').val(newLeftCount).trigger('change');
}

// Inventory-error surface: a lightweight modal dialog shown when /cart/add
// responds non-2xx (typically 422 "sold out" or "only X added due to
// availability"). Dismissing the modal reloads the page so the drawer/bubble
// pick up whatever actually got added server-side — simpler and more reliable
// than trying to re-sync cart sections client-side.
function showBundleError(message) {
  closeBundleErrorModal();
  var $overlay = $(
    '<div class="bundle-error-modal" role="dialog" aria-modal="true" aria-labelledby="bundle-error-title">' +
      '<div class="bundle-error-modal__dialog">' +
        '<button type="button" class="bundle-error-modal__close" aria-label="Close">&times;</button>' +
        '<h2 id="bundle-error-title" class="bundle-error-modal__title">Unable to add to cart</h2>' +
        '<p class="bundle-error-modal__message"></p>' +
        '<button type="button" class="bundle-error-modal__ok">OK</button>' +
      '</div>' +
    '</div>'
  );
  $overlay.find('.bundle-error-modal__message').text(message);
  $('body').append($overlay).addClass('overflow-hidden');

  // All dismissal paths reload — ensures the cart UI reflects any partial
  // fulfillment Shopify performed before erroring.
  var dismiss = function () { window.location.reload(); };
  $overlay.on('click', function (e) { if (e.target === this) dismiss(); });
  $overlay.find('.bundle-error-modal__close, .bundle-error-modal__ok').on('click', dismiss);
  $(document).on('keyup.bundleErrorModal', function (e) { if (e.key === 'Escape') dismiss(); });

  // Focus the OK button for keyboard accessibility
  setTimeout(function () { $overlay.find('.bundle-error-modal__ok').trigger('focus'); }, 0);
}

// Silent close without reload — used internally by showBundleError to remove
// any stale modal before injecting a new one, and by clearBundleError for
// pre-submission cleanup (e.g. shopper changes bundle selection).
function closeBundleErrorModal() {
  $('.bundle-error-modal').remove();
  $('body').removeClass('overflow-hidden');
  $(document).off('keyup.bundleErrorModal');
}

// Invoked when the shopper edits the bundle (item added/removed) so a stale
// error modal from a prior failed add doesn't linger over the new bundle state.
function clearBundleError() {
  closeBundleErrorModal();
}

// Reads /cart.js and, for each item about to be POSTed, copies the existing
// variant's line-item properties onto the item so Shopify can merge cleanly.
// Form-level properties (none on the bundle surface today, but handled anyway)
// win on conflict. Silently no-ops on any failure so the add can proceed.
function freshenBundleItems(cartItems) {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart || !cart.items) return;
      var byVariant = {};
      cart.items.forEach(function (line) {
        var k = String(line.variant_id);
        if (!byVariant[k]) byVariant[k] = line.properties || {};
      });
      cartItems.forEach(function (item) {
        var existing = byVariant[String(item.id)];
        if (existing && Object.keys(existing).length > 0) {
          item.properties = Object.assign({}, existing, item.properties || {});
        }
      });
    })
    .catch(function () { /* non-fatal */ });
}

// Re-fetch current cart state and drive a full drawer re-render via the
// cart-drawer element's own renderContents() — the same method product-form.js
// and cart.js use. This ensures all of the drawer's internal state (is-empty
// class, overlay rebind, open-on-render) is handled consistently.
//
// Used in three scenarios:
//   1) Success path, 1800ms after initial render — catches Redo's post-add
//      mutations (property writes + re-keying) so the drawer reflects server
//      truth a couple of seconds after Redo reconciles.
//   2) Error path, immediately + open — Shopify may partially fulfill a
//      multi-item add (e.g. "only 2 of 3 added, 1 was out of stock").
//      We re-sync the drawer and open it so the shopper can see what DID
//      get added when they dismiss the error modal.
//   3) Network failure — safe re-sync to whatever the server actually has.
var _bundleRefreshTimer = null;
function refreshBundleDrawer(openAfter) {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return Promise.resolve();
  return fetch('/cart?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data) return;
      if (typeof drawer.renderContents === 'function') {
        // renderContents expects { sections: { [id]: html }, id }
        // It sets innerHTML for each configured section AND calls open().
        drawer.renderContents({ sections: data, id: null });
      } else {
        // Fallback: direct innerHTML replacement if the custom element
        // hasn't upgraded yet (rare edge case)
        var drawerHtml = data['cart-drawer'];
        if (drawerHtml) {
          var parsed = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('cart-drawer');
          if (parsed) drawer.innerHTML = parsed.innerHTML;
        }
        var bubbleHtml = data['cart-icon-bubble'];
        if (bubbleHtml) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var parsedBubble = new DOMParser()
              .parseFromString(bubbleHtml, 'text/html')
              .querySelector('.shopify-section');
            if (parsedBubble) bubble.innerHTML = parsedBubble.innerHTML;
          }
        }
        if (openAfter && typeof drawer.open === 'function') drawer.open();
      }
    })
    .catch(function () { /* non-fatal */ });
}

function scheduleBundleDrawerRefresh() {
  if (_bundleRefreshTimer) clearTimeout(_bundleRefreshTimer);
  _bundleRefreshTimer = setTimeout(function () { refreshBundleDrawer(false); }, 1800);
}

function parseCartAddError(responseText) {
  var fallback = 'One or more items in your bundle are unavailable. Please adjust your selection and try again.';
  if (!responseText) return fallback;
  try {
    var data = JSON.parse(responseText);
    // Shopify returns: { status, message, description }
    // description is usually the nicer shopper-facing variant
    var raw = data.description || data.message || '';
    if (!raw) return fallback;
    // Common shape: "The product 'X' is already sold out."
    // Wrap it with guidance so the shopper knows what to do
    var soldOutMatch = raw.match(/The product ['"\u2018\u2019](.+?)['"\u2018\u2019] is already sold out/i);
    if (soldOutMatch) {
      return 'Sorry, ' + soldOutMatch[1] + ' is sold out. Please remove it from your bundle to continue.';
    }
    return raw;
  } catch (e) {
    return fallback;
  }
}

// Helper to maintain correct CTA label and state
function updateBundleCTA() {
  var filledSpots = $('.bundle-bottom-wrap .bundle-block-items .added-item').length;
  var remaining = Math.max(0, 2 - filledSpots);

  var $btn = $('.bundle-bottom-wrap .bundle-add-to-cart');
  $btn.find('.count').text(remaining);

  if (filledSpots >= 2) {
    $btn.addClass('active').attr('disabled', false);
  } else {
    $btn.removeClass('active').attr('disabled', true);
  }
}

$(document).on('click', '.bundle-item .add-bundle', function () {
  if (!$(this).hasClass('out-of-stock')) {
    var leftBundleCount = $('input[name="left-bundle-count"]').val(),
      bundleItem = $(this).parent('.bundle-item'),
      variantID = bundleItem.find('input[name="default-variant"]').val(),
      itemImg = bundleItem.find('.size-variant.active').data('img'),
      activeColors = bundleItem.find('.color-for-size.active'),
      placeholderItem = $('.bundle-block-items .block-item').not('.added-item').eq(0);

    if (activeColors.length > 0) {
      itemImg = activeColors.find('.active').data('img');
      variantID = activeColors.find('.active').data('variant-id');
    }

    if (leftBundleCount > 0) {
      placeholderItem.attr('data-id', variantID);
      placeholderItem.append('<img src="' + itemImg + '" class="item-image"/><span class="remove">&#215;</span>');
      placeholderItem.addClass('added-item');

      $('input[name="left-bundle-count"]')
        .val(parseInt(leftBundleCount) - 1)
        .trigger('change');
      updateBundleCTA();

      // Update discount labels
      updateDiscountLabels();

      // Manage bundle spots automatically
      manageBundleSpots();

      // Any pending inventory error no longer applies to the new bundle state
      clearBundleError();
    }
  }
});

$(document).on('click', '.bundle-block-items .block-item .remove', function () {
  var $this = $(this),
    blockItem = $this.parent('.block-item'),
    leftBundleCount = $('input[name="left-bundle-count"]').val();

  blockItem.remove();
  blockTtemsWrap.append('<div class="block-item"><span class="placeholder">ONO</span></div>');
  clearBundleError();

  $('input[name="left-bundle-count"]')
    .val(parseInt(leftBundleCount) + 1)
    .trigger('change');
  updateBundleCTA();

  // Update discount labels
  updateDiscountLabels();

  // Manage bundle spots automatically
  manageBundleSpots();
});

$('input[name="left-bundle-count"]').on('change', function () {
  updateBundleCTA();
});

// Initialize CTA on load (after DOM is ready)
$(function () {
  updateBundleCTA();
});

$(document).on('click', '.bundle-add-to-cart:not([disabled])', function () {
  var $this = $(this);

  if ($this.hasClass('loading')) return;

  // Consolidate items by variant ID so duplicates become quantity > 1
  var itemMap = {};
  $('.bundle-bottom-wrap .bundle-block-items .block-item[data-id]').each(function () {
    var id = String($(this).data('id'));
    if (itemMap[id]) {
      itemMap[id].quantity += 1;
    } else {
      itemMap[id] = { id: Number(id), quantity: 1 };
    }
  });

  var cartParams = [];
  for (var key in itemMap) {
    cartParams.push(itemMap[key]);
  }

  if (cartParams.length === 0) return;

  $this.addClass('loading').attr('disabled', true);

  // Pre-add freshen: Redo (and similar third-party apps) inject line-item
  // properties async after /cart/add. If an existing cart line already has
  // those properties and we POST with properties:{}, Shopify creates a
  // duplicate instead of merging. Read /cart.js first and copy matching
  // variants' properties onto our payload. Same pattern as product-form.js.
  freshenBundleItems(cartParams).then(function () {
    // Use XMLHttpRequest instead of fetch to avoid Shopify's shop_events_listener
    // intercepting the request and firing per-item analytics calls that cascade
    // into dozens of /cart.js requests and trigger 429 rate limits.
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        clearBundleError();
        var data = JSON.parse(xhr.responseText);

        var sectionHtml = data.sections && data.sections['cart-drawer'];
        if (sectionHtml) {
          var drawerEl = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('cart-drawer');
          document.querySelector('cart-drawer').innerHTML = drawerEl.innerHTML;

          if (document.querySelector('cart-drawer').classList.contains('is-empty')) {
            document.querySelector('cart-drawer').classList.remove('is-empty');
          }

          document.querySelector('cart-drawer').open();
        }

        $this.removeClass('loading').attr('disabled', false);

        // Schedule a delayed drawer refresh to pick up any post-add mutations
        // Redo performs ~1-2s later (property writes, re-keying). The initial
        // render from response.sections is instant for UX; this second pass
        // reconciles against current server state.
        scheduleBundleDrawerRefresh();
      } else {
        $this.removeClass('loading').attr('disabled', false);
        var friendlyMessage = parseCartAddError(xhr.responseText);
        showBundleError(friendlyMessage);
        console.error('Error adding to cart:', xhr.status, xhr.responseText);
      }
    };
    xhr.onerror = function () {
      $this.removeClass('loading').attr('disabled', false);
      showBundleError('We couldn\u2019t reach the cart. Please check your connection and try again.');
      console.error('Error adding to cart: network error');
    };
    xhr.send(JSON.stringify({
      items: cartParams,
      sections: 'cart-drawer',
    }));
  });
});

function bundleGroupSlide() {
  if ($(window).width() < 992) {
    if (!$('.bundle-main-content .tab-content-inner').hasClass('slick-initialized')) {
      $('.bundle-main-content .tab-content-inner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        prevArrow:
          "<div class='slick-prev slick-arrow'><svg class='icon'><use xlink:href='#icon-chevron-left' /></svg></div>",
        nextArrow:
          "<div class='slick-next slick-arrow'><svg class='icon'><use xlink:href='#icon-chevron-right' /></svg></div>",
      });
    }
  } else {
    if ($('.bundle-main-content .tab-content-inner').hasClass('slick-initialized')) {
      //$('.bundle-main-content .tab-content-inner').slick('unslick');
    }
  }
}

/*
$(window).on('resize', function () {
  bundleGroupSlide();
});

bundleGroupSlide();
*/

$('.bundle-item .bundle-options .size-variant').each(function () {
  if ($(this).data('size') == 'Junior') $(this).click();
});

/* 
=
=
== Cart stuff */

$(document).ready(function () {
  var country_code = 'US';
  fetch('https://geolocation.developers-efd.workers.dev/?x-api-key=5de3921b-dd40-4eb0-8578-236de4f2f3a4', {
    method: 'POST',
    mode: 'cors',
  })
    .then((response) => response.json())
    .then((response) => {
      country_code = response.data.country.iso_code;
    })
    .catch((err) => console.error(err));

  $(document).on('click', '.upsell-product-item button.btn--addToCart', function (e) {
    e.preventDefault();

    var $this = $(this),
      product = $this.parents('.upsell-product-item');
    (variantID = product.find('.upsell-product-image:not(.hide)').data('variant-id')),
      (triggerVal = $('input[name=trigger-upsell-added]'));

    $this.addClass('loading');

    $.ajax({
      // Add items to Cart
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantID,
        quantity: 1,
      },
      dataType: 'json',
      success: function () {
        $this.removeClass('loading');
        triggerVal.val(parseInt(triggerVal.val()) + 1).trigger('change');
        $('.cart-quickview_content').animate({ scrollTop: 0 });
        ajaxBundleState();
      },
    });
  });

  // Initialize discount labels on page load
  updateDiscountLabels();
});

var ajaxBundleState = () => {
  $.ajax({
    // Get items to Cart
    type: 'GET',
    url: '/cart?view=info',
    success: function (res) {
      var cartObj = JSON.parse(res),
        $container = $('.bundle-product-status'),
        totalCount = 3,
        currentCount = 0,
        discountPercent = 15,
        totalPrice = cartObj.total_price / 100,
        freeShippingPrice = parseFloat($container.data('freeshipping-price')),
        cartItems = cartObj.items,
        upsell_roller = false,
        upsell_scroller = false,
        upsell_slider = false;

      $.each(cartItems, function (index, item) {
        var itemQty = item.quantity;
        currentCount = currentCount + itemQty;

        if (item.tags.includes('Roller')) upsell_roller = true;
        if (item.tags.includes('Scroller')) upsell_scroller = true;
        if (item.tags.includes('Slider')) upsell_slider = true;
      });

      $('.upsell-item-wrap').removeClass('hide');
      if (upsell_roller == false) $('.upsell-item-roller').addClass('hide');
      if (upsell_scroller == false) $('.upsell-item-scroller').addClass('hide');
      if (upsell_slider == false) $('.upsell-item-slider').addClass('hide');

      if (currentCount >= 3) {
        totalCount = 4;
        discountPercent = 20;
      }

      $container.empty();

      if (currentCount < totalCount) {
        // $container.append('<div class="bundle-product-status-inner"></div');

        // $container.find('.count-desc').html('Your case: <span class="current-count">'+ currentCount +'</span>/<span class="total-count">'+ totalCount +'</span> items');
        // $container.find('.discount-desc').html('Add more <span class="left-count">'+ (totalCount - currentCount) +'</span> for <span class="discount-percent">'+ discountPercent +'</span>% Off!');

        // for ( let i = 1; i <= totalCount; i++ ) {
        //   if ( i <= currentCount ) {
        //     $container.find('.count-dots').append('<span class="dot"></span>');
        //   } else {
        //     $container.find('.count-dots').append('<span class="dot dot-empty"></span>');
        //   }
        // }

        if (freeShippingPrice <= totalPrice && country_code == 'US') {
          if (currentCount >= 3) {
            $container.append(
              '<span class="free-shipping-success">You`ve unlocked <strong>Free Shipping + 15% Off</strong></span>'
            );
          } else {
            $container.append(
              '<span class="free-shipping-success">You`ve unlocked <strong>Free Shipping</strong></span>'
            );
          }
        }
        if (freeShippingPrice > totalPrice && country_code == 'US')
          $container.append(
            '<span class="free-shipping-progress">You`re $' +
              (freeShippingPrice - totalPrice).toFixed(2) +
              ' away from <strong>Free Shipping</strong></span>'
          );
        $container.append(
          '<span class="bundle-status-case discount-desc">Add <span class="left-count">' +
            (totalCount - currentCount) +
            '</span> more fidget for <strong><span class="discount-percent">' +
            discountPercent +
            '</span>% Off<strong></span>'
        );
      } else {
        if (country_code == 'US') {
          $container.append(
            '<span class="bundle-status-case final-desc">You`ve unlocked <strong>Free Shipping + ' +
              discountPercent +
              '% Off</strong></span>'
          );
        } else {
          $container.append(
            '<span class="bundle-status-case final-desc">You`ve unlocked <strong>  ' +
              discountPercent +
              '% Off</strong></span>'
          );
        }
      }
    },
  });
};

// Function to update discount labels based on bundle count
function updateDiscountLabels() {
  var filledSpots = $('.bundle-block-items .added-item').length;
  var discount2Item = $('.discount-item').first();
  var discount3Item = $('.discount-item').last();
  var discount2Checkbox = $('#discount-2');
  var discount3Checkbox = $('#discount-3');

  // Update "Buy 2 get 15% off" label
  if (filledSpots >= 2) {
    discount2Item.removeClass('disabled').addClass('enabled');
    discount2Checkbox.prop('disabled', false).prop('checked', true);
  } else {
    discount2Item.removeClass('enabled').addClass('disabled');
    discount2Checkbox.prop('disabled', true).prop('checked', false);
  }

  // Update "Buy 3 get 20% off" label
  if (filledSpots >= 3) {
    discount3Item.removeClass('disabled').addClass('enabled');
    discount3Checkbox.prop('disabled', false).prop('checked', true);
  } else {
    discount3Item.removeClass('enabled').addClass('disabled');
    discount3Checkbox.prop('disabled', true).prop('checked', false);
  }
}

// Scroll event handler for sticky discount notification
document.addEventListener('DOMContentLoaded', function () {
  const discountNotification = document.querySelector('.discount-notification');
  const bundleWrapper = document.querySelector('.bundle-group-wrapper');

  if (discountNotification && bundleWrapper) {
    const offset = discountNotification.offsetTop;

    // Initialize with 'at-top' class on page load
    document.body.classList.add('at-top');

    function handleScroll() {
      if (window.scrollY >= offset) {
        discountNotification.classList.add('sticky');
        bundleWrapper.classList.add('is-sticky');
      } else {
        discountNotification.classList.remove('sticky');
        bundleWrapper.classList.remove('is-sticky');
      }

      // Remove at-top class with additional 100px offset
      if (window.scrollY >= offset + 160) {
        document.body.classList.remove('at-top');
      } else {
        document.body.classList.add('at-top');
      }
    }

    window.addEventListener('scroll', handleScroll);
  }
});
